export const colors = {
  primary: "#1094CC",
  primaryLightest: "#F1FBFF",
  primaryDark: "#093C5F",
  active: "#1AB1F1",
  text: "#4C4C4E",
  grad1: "#E67171",
  grad2: "#DAAF94",
  grad3: "#BEDA94",
  grad4: "#67DEC7",
  grad5: "#58B4DB",
  empty: "#E2E2E2"
};

export const dataGradient = {
  normal: `linear-gradient(to right, ${colors.grad1}, ${colors.grad2}, ${
    colors.grad3
  }, ${colors.grad4}, ${colors.grad5})`,
  reverse: `linear-gradient(to right, ${colors.grad5}, ${colors.grad4}, ${
    colors.grad3
  }, ${colors.grad2}, ${colors.grad1})`
};

export const navbarHeight = 90;



// WEBPACK FOOTER //
// ./src/consts.js